module.exports = __webpack_public_path__ + "img/Star-filled.3c3b98e3.svg";